export default "__VITE_ASSET__9ZTUNZ7X__"